// 矿山种类
export const mineOptions = [
  '煤（地下开采）',
  '煤（露天开采）',
  '石油',
  '油页岩',
  '烃类天然气',
  '二氧化碳气',
  '煤成(层)气',
  '地热(热水)',
  '地热(热气)',
  '放射性矿产',
  '金(岩金)',
  '金(砂金船采)',
  '金(砂金机采)',
  '银',
  '其他贵金属',
  '铁（地下开采）',
  '铁（露天开采）',
  '锰',
  '铬、钛、钒',
  '铜',
  '铅',
  '锌',
  '钨',
  '锡',
  '锑',
  '铝土矿',
  '钼',
  '镍',
  '钴',
  '镁',
  '铋',
  '汞',
  '稀土、稀有金属',
  '石灰岩',
  '硅石',
  '白云岩',
  '耐火粘土',
  '萤石',
  '硫铁矿',
  '自然硫',
  '磷矿',
  '蛇纹岩',
  '硼矿',
  '岩盐、井盐',
  '湖盐',
  '钾盐',
  '芒硝',
  '碘',
  '砷、雌黄、雄黄、毒砂',
  '金刚石',
  '宝石',
  '云母',
  '石棉',
  '重晶石',
  '石膏',
  '滑石',
  '长石',
  '高岭土、瓷土等',
  '膨润土',
  '叶蜡石',
  '沸石',
  '石墨',
  '玻璃用砂、砂岩',
  '水泥用砂岩',
  '建筑石料',
  '建筑用砂、砖瓦粘土',
  '页岩',
  '矿泉水'
]
// 企业类型
export const industryOptions = [
  {
    value: 1,
    label: '工业风险单元',
    children: [
      {
        disabled: false,
        value: 101,
        label: '危险化学品生产企业'
      },
      {
        disabled: false,
        value: 102,
        label: '带储存的危险化学品经营企业'
      },
      {
        disabled: false,
        value: 103,
        label: '危险化学品使用企业'
      },
      {
        disabled: false,
        value: 104,
        label: '加油站'
      },
      {
        disabled: false,
        value: 105,
        label: '天然气站场'
      },
      {
        disabled: false,
        value: 106,
        label: '液化气储配站（含供应站）'
      },
      {
        disabled: false,
        value: 107,
        label: '冶金企业'
      },
      {
        disabled: false,
        value: 108,
        label: '有色企业'
      },
      {
        disabled: false,
        value: 109,
        label: '民用爆炸物品企业'
      },
      {
        disabled: false,
        value: 110,
        label: '建材企业'
      },
      {
        disabled: false,
        value: 121,
        label: '轻工企业'
      },
      {
        disabled: false,
        value: 111,
        label: '机械企业'
      },
      {
        disabled: false,
        value: 112,
        label: '纺织企业'
      },
      {
        disabled: false,
        value: 113,
        label: '电力企业'
      },
      {
        disabled: false,
        value: 114,
        label: '露天矿山'
      },
      {
        disabled: false,
        value: 115,
        label: '地下矿山'
      },
      {
        disabled: false,
        value: 116,
        label: '尾矿库'
      },
      {
        disabled: false,
        value: 117,
        label: '烟花爆竹企业'
      },
      {
        disabled: false,
        value: 118,
        label: '港口经营企业（泉州港口）'
      },
      {
        disabled: false,
        value: 119,
        label: '铁路货运站场'
      },
      {
        disabled: false,
        value: 120,
        label: '建筑业'
      },
      {
        disabled: false,
        value: 122,
        label: '农业与农机(农药、兽药)'
      },
      {
        disabled: false,
        value: 123,
        label: '农机(含农机作业)'
      },
      {
        disabled: false,
        value: 124,
        label: '农业与农机(农产品初加工、饲料及饲料添加剂生产)'
      },
      {
        disabled: false,
        value: 126,
        label: '机动车维修企业'
      },
      {
        disabled: false,
        value: 127,
        label: '粮食和物资储备行业'
      },
      {
        disabled: false,
        value: 128,
        label: '烟草'
      },
      {
        disabled: false,
        value: 129,
        label: '林业'
      },
      {
        disabled: false,
        value: 132,
        label: '农田水利建设'
      },
      {
        disabled: false,
        value: 133,
        label: '公路、水运工程'
      },
      {
        disabled: false,
        value: 134,
        label: '房地产业(含房地产开发、房屋征收拆迁等)'
      },
      {
        disabled: false,
        value: 135,
        label: '水利工程'
      },
      {
        disabled: false,
        value: 136,
        label: '民爆物品(爆破)'
      },
      {
        disabled: false,
        value: 137,
        label: '特种设备生产企业'
      },
      {
        disabled: false,
        value: 138,
        label: '港口经营企业（湄洲湾港口）'
      },
      {
        disabled: false,
        value: 141,
        label: '加气站'
      }
    ]
  },
  {
    disabled: false,
    value: 2,
    label: '人员密集场所单元',
    children: [
      {
        value: 201,
        label: '餐饮场所'
      },
      {
        value: 202,
        label: '医疗机构'
      },
      {
        value: 203,
        label: '房地产业（物业服务）'
      },
      {
        value: 204,
        label: '宗教场所'
      },
      {
        value: 205,
        label: '体育场馆'
      },
      {
        value: 206,
        label: '城市公园'
      },
      {
        value: 207,
        label: '学校'
      },
      {
        value: 208,
        label: '宾馆酒店（非星级）'
      },
      {
        value: 209,
        label: '养老机构和福利机构'
      },
      {
        value: 210,
        label: '文化行业'
      },
      {
        value: 211,
        label: '商贸'
      },
      {
        value: 213,
        label: '技工院校和职业培训机构'
      },
      {
        value: 214,
        label: '新闻出版'
      },
      {
        value: 215,
        label: '文物和博物馆'
      },
      {
        value: 216,
        label: '星级饭店（酒店）'
      },
      {
        value: 217,
        label: '商贸（医药及医疗器材）'
      },
      {
        disabled: false,
        value: 229,
        label: '驾校'
      }
    ]
  },
  {
    disabled: false,
    value: 3,
    label: '公共设施单元',
    children: [
      {
        value: 301,
        label: '城市桥梁'
      },
      {
        value: 302,
        label: '城市隧道'
      },
      {
        value: 303,
        label: '水库大坝'
      },
      {
        value: 304,
        label: '客运车站'
      },
      {
        value: 305,
        label: '旅行社'
      },
      {
        value: 306,
        label: '陆上油气长输管道企业'
      },
      {
        value: 307,
        label: '城镇燃气管道企业'
      },
      {
        value: 308,
        label: '危险货物道路运输企业'
      },
      {
        value: 309,
        label: '建筑垃圾受纳场'
      },
      {
        value: 310,
        label: '渔业船舶'
      },
      {
        value: 312,
        label: '城市垃圾处理企业'
      },
      {
        value: 313,
        label: '散装物料运输企业'
      },
      {
        value: 314,
        label: '普通货物运输企业'
      },
      {
        value: 315,
        label: '邮政(含快递)'
      },
      {
        disabled: false,
        value: 316,
        label: '城市供水企业'
      },
      {
        disabled: false,
        value: 317,
        label: '污水处理企业'
      },
      {
        disabled: false,
        value: 318,
        label: '农村水电站'
      },
      {
        disabled: false,
        value: 319,
        label: '公路客运企业'
      },
      {
        value: 320,
        label: '水路旅客运输企业'
      },
      {
        disabled: false,
        value: 335,
        label: '水路货物运输企业'
      }
    ]
  }
]
// 风险等级
export const levelOptions = [
  { label: '重大风险', value: 1 },
  { label: '较大风险', value: 2 },
  { label: '一般风险', value: 3 },
  { label: '低风险', value: 4 }
]

export const standardOptionA = ['评审达标', '自评达标', '未创建标准化']

export const standardOptionB = ['国家标准', '省级标准', '泉州标准']

export const standardOptionC = ['一级', '二级', '三级', '不定级(泉州标准达标)']

export const firestandardOptions = ['已达标', '未达标', '未创建']
export const funeralOptions = ['一级', '二级', '三级', '未评定']
export const isStandardOptions = [
  '一级达标',
  '二级达标',
  '三级达标',
  '小微达标'
]
export const isFuneralOptions = ['一级', '二级', '三级']
export const isfireStandardOptions = ['已达标']
// 标准化创建
export const standardOptions = [
  {
    value: '评审达标',
    label: '评审达标',
    children: [
      {
        value: '国家标准',
        label: '国家标准',
        children: [
          {
            value: '一级',
            label: '一级'
          },
          {
            value: '二级',
            label: '二级'
          },
          {
            value: '三级',
            label: '三级'
          },
          {
            value: '不定级',
            label: '不定级'
          }
        ]
      },
      {
        value: '省级标准',
        label: '省级标准',
        children: [
          {
            value: '一级',
            label: '一级'
          },
          {
            value: '二级',
            label: '二级'
          },
          {
            value: '三级',
            label: '三级'
          },
          {
            value: '不定级',
            label: '不定级'
          }
        ]
      },
      {
        value: '泉州标准',
        label: '泉州标准',
        children: [
          {
            value: '一级',
            label: '一级'
          },
          {
            value: '二级',
            label: '二级'
          },
          {
            value: '三级',
            label: '三级'
          },
          {
            value: '不定级（泉州标准达标）',
            label: '不定级（泉州标准达标）'
          }
        ]
      }
    ]
  },
  {
    value: '自评达标',
    label: '自评达标',
    children: [
      {
        value: '国家标准',
        label: '国家标准',
        children: [
          {
            value: '一级',
            label: '一级'
          },
          {
            value: '二级',
            label: '二级'
          },
          {
            value: '三级',
            label: '三级'
          },
          {
            value: '不定级',
            label: '不定级'
          }
        ]
      },
      {
        value: '省级标准',
        label: '省级标准',
        children: [
          {
            value: '一级',
            label: '一级'
          },
          {
            value: '二级',
            label: '二级'
          },
          {
            value: '三级',
            label: '三级'
          },
          {
            value: '不定级',
            label: '不定级'
          }
        ]
      },
      {
        value: '泉州标准',
        label: '泉州标准',
        children: [
          {
            value: '一级',
            label: '一级'
          },
          {
            value: '二级',
            label: '二级'
          },
          {
            value: '三级',
            label: '三级'
          },
          {
            value: '不定级（泉州标准达标）',
            label: '不定级（泉州标准达标）'
          }
        ]
      }
    ]
  },
  {
    value: '未创建标准化',
    label: '未创建'
  }
]
// 标准化映射
export const standardMap = {
  '评审达标,国家标准,一级': '国标一级',
  '评审达标,国家标准,二级': '国标二级',
  '评审达标,国家标准,三级': '国标三级',
  '评审达标,国家标准,不定级': '国标不定级',
  '评审达标,省级标准,一级': '省标一级',
  '评审达标,省级标准,二级': '省标二级',
  '评审达标,省级标准,三级': '省标三级',
  '评审达标,省级标准,不定级': '省标不定级',
  '评审达标,泉州标准,一级': '泉州一级',
  '评审达标,泉州标准,二级': '泉州二级',
  '评审达标,泉州标准,三级': '泉州三级',
  '评审达标,泉州标准,不定级（泉州标准达标）': '泉州标准化达标',
  '自评达标,国家标准,一级': '国标一级（自评）',
  '自评达标,国家标准,二级': '国标二级（自评）',
  '自评达标,国家标准,三级': '国标三级（自评）',
  '自评达标,国家标准,不定级': '不定级（自评）',
  '自评达标,省级标准,一级': '省标一级（自评）',
  '自评达标,省级标准,二级': '省标二级（自评）',
  '自评达标,省级标准,三级': '省标三级（自评）',
  '自评达标,省级标准,不定级': '省标不定级（自评）',
  '自评达标,泉州标准,一级': '泉州一级（自评）',
  '自评达标,泉州标准,二级': '泉州二级（自评）',
  '自评达标,泉州标准,三级': '泉州三级（自评）',
  '自评达标,泉州标准,泉州标准达标': '泉州标准化达标（自评）',
  未创建标准化: '未创建标准化'
}

// 九小场所
export const nineSmallPlaceType = [
  {
    value: '九小场所',
    label: '九小场所',
    children: [
      {
        value: '小商店',
        label: '小商店'
      },
      {
        value: '小旅馆',
        label: '小旅馆'
      },
      {
        value: '小学校（幼儿园、校外培训机构）',
        label: '小学校（幼儿园、校外培训机构）'
      },
      {
        value: '小医院（诊所、养老院）',
        label: '小医院（诊所、养老院）'
      },
      {
        value: '小网吧',
        label: '小网吧'
      },
      {
        value: '小餐饮馆',
        label: '小餐饮馆'
      },
      {
        value: '小歌舞娱乐场所',
        label: '小歌舞娱乐场所'
      },
      {
        value: '小美容洗浴场所',
        label: '小美容洗浴场所'
      },
      {
        value: '小生产加工企业',
        label: '小生产加工企业'
      }
    ]
  }
]
// 单位规模
export const scaleOptions = ['大型', '中型', '小型', '微型']

// 人员类型
export const staffTypeOptions = [
  '主要负责人',
  '安全管理人员',
  '其他管理人员',
  '一线生产人员',
  '其他人员',
  '特种作业人员',
  '特种设备作业人员'
]

export const controlLevelOptions = {
  1: '岗位',
  2: '部门',
  3: '单位'
}

export const frequencyTypeOptions = {
  1: '小时 / 次',
  2: '天 / 次',
  3: '周 / 次',
  4: '月 / 次',
  5: '年 / 次'
}

// 危险作业类型
export const dangerOptions = [
  '动火作业',
  '有限空间作业',
  '高处作业',
  '吊装作业',
  '断路作业',
  '动土作业',
  '临时用电作业',
  '盲板抽堵作业'
]
export const rateColors = ['#99A9BF', '#F7BA2A', '#FF9900']
export const flowStatusOptions = [
  {
    // 危险作业状态
    label: '未开始',
    value: 0
  },
  {
    label: '进行中',
    value: 1
  },
  {
    label: '已关闭',
    value: 2
  },
  {
    label: '逾期未关闭',
    value: 3
  }
]

export const clearStatusOptions = [
  {
    // 销号状态
    label: '挂牌督办待审核',
    value: 1
  },
  {
    label: '打回一般隐患',
    value: 2
  },
  {
    label: '挂牌督办中',
    value: 3
  },
  {
    label: '摘牌销案待审核',
    value: 4
  },
  {
    label: '已摘牌销案',
    value: 5
  }
]

export const categoryOption = [
  {
    disabled: false,
    value: '基础管理',
    label: '基础管理',
    children: [
      {
        disabled: false,
        value: '生产经营单位资质证照类',
        label: '生产经营单位资质证照类'
      },
      {
        disabled: false,
        value: '安全生产管理机构及人员类',
        label: '安全生产管理机构及人员类'
      },
      {
        disabled: false,
        value: '安全生产责任制类',
        label: '安全生产责任制类'
      },
      {
        disabled: false,
        value: '安全生产管理制度类',
        label: '安全生产管理制度类'
      },
      {
        disabled: false,
        value: '安全操作规程类',
        label: '安全操作规程类'
      },
      {
        disabled: false,
        value: '教育培训类',
        label: '教育培训类'
      },
      {
        disabled: false,
        value: '安全生产管理档案类',
        label: '安全生产管理档案类'
      },
      {
        disabled: false,
        value: '安全生产投入类',
        label: '安全生产投入类'
      },
      {
        disabled: false,
        value: '应急管理类',
        label: '应急管理类'
      },
      {
        disabled: false,
        value: '特种设备基础管理类',
        label: '特种设备基础管理类'
      },
      {
        disabled: false,
        value: '职业卫生基础管理类',
        label: '职业卫生基础管理类'
      },
      {
        disabled: false,
        value: '相关方基础管理类',
        label: '相关方基础管理类'
      },
      {
        disabled: false,
        value: '其他基础管理类',
        label: '其他基础管理类'
      }
    ]
  },
  {
    disabled: false,
    value: '现场管理',
    label: '现场管理',
    children: [
      {
        disabled: false,
        value: '特种设备现场管理类',
        label: '特种设备现场管理类'
      },
      {
        disabled: false,
        value: '生产设备设施及工艺类',
        label: '生产设备设施及工艺类'
      },
      {
        disabled: false,
        value: '场所环境类',
        label: '场所环境类'
      },
      {
        disabled: false,
        value: '从业人员操作行为类',
        label: '从业人员操作行为类'
      },
      {
        disabled: false,
        value: '消防安全类',
        label: '消防安全类'
      },
      {
        disabled: false,
        value: '用电安全类',
        label: '用电安全类'
      },
      {
        disabled: false,
        value: '职业卫生现场安全类',
        label: '职业卫生现场安全类'
      },
      {
        disabled: false,
        value: '有限空间现场安全类',
        label: '有限空间现场安全类'
      },
      {
        disabled: false,
        value: '辅助动力系统类',
        label: '辅助动力系统类'
      },
      {
        disabled: false,
        value: '相关方现场管理类',
        label: '相关方现场管理类'
      },
      {
        disabled: false,
        value: '其他现场管理类',
        label: '其他现场管理类'
      }
    ]
  }
]

// 带有八大行业的企业类型
export const industryList = [
  {
    value: 1,
    label: '矿山',
    children: [
      {
        value: 114,
        label: '露天矿山'
      }
    ]
  },
  {
    value: 2,
    label: '危险化学品',
    children: [
      {
        value: 101,
        label: '危险化学品生产企业'
      },
      {
        disabled: false,
        value: 102,
        label: '带储存的危险化学品经营企业'
      },
      {
        disabled: false,
        value: 103,
        label: '危险化学品使用企业'
      },
      {
        disabled: false,
        value: 104,
        label: '加油站'
      }
    ]
  },
  {
    value: 3,
    label: '烟花爆竹',
    children: [
      {
        disabled: false,
        value: 117,
        label: '烟花爆竹企业'
      }
    ]
  },
  {
    value: 4,
    label: '交通运输',
    children: [
      {
        value: 322,
        label: '城市轨道交通（地铁）'
      },
      {
        value: 321,
        label: '城市道路公共交通运营企业'
      },
      {
        value: 308,
        label: '道路危险货物运输企业'
      },
      {
        value: 319,
        label: '公路客运企业'
      }
    ]
  },
  {
    value: 5,
    label: '建筑施工',
    children: [
      {
        value: 139,
        label: '房屋建设'
      }
    ]
  },
  {
    value: 6,
    label: '民用爆炸物品',
    children: [
      {
        value: 109,
        label: '民用爆炸物品企业'
      }
    ]
  },
  {
    value: 7,
    label: '金属冶炼',
    children: [
      {
        value: 107,
        label: '冶金企业'
      }
    ]
  },
  {
    value: 8,
    label: '渔业生产',
    children: [
      {
        value: 310,
        label: '渔业船舶'
      }
    ]
  },
  {
    value: 9,
    label: '工业风险单元',
    children: [
      {
        disabled: false, // 104
        value: 140,
        label: '加油加气站'
      },
      {
        disabled: false, // 104
        value: 141,
        label: '加气站'
      },
      {
        disabled: false,
        value: 108,
        label: '有色企业'
      },
      {
        disabled: false,
        value: 110,
        label: '建材企业'
      },
      {
        disabled: false,
        value: 121,
        label: '轻工企业'
      },
      {
        disabled: false,
        value: 111,
        label: '机械企业'
      },
      {
        disabled: false,
        value: 112,
        label: '纺织企业'
      },
      {
        disabled: false, // 111
        value: 142,
        label: '汽车制造企业'
      },
      {
        disabled: false, // 111
        value: 144,
        label: '船舶修造企业'
      },
      {
        disabled: false,
        value: 105,
        label: '天然气站场'
      },
      {
        disabled: false,
        value: 145,
        label: '危险废物处置企业'
      },
      {
        disabled: false,
        value: 118,
        label: '港口经营企业'
      },
      {
        disabled: false,
        value: 126,
        label: '机动车维修企业'
      },
      {
        disabled: false,
        value: 106,
        label: '液化气储配站（含供应站）'
      },
      {
        value: 330, // 111
        label: '民航设施维修产业'
      }
    ]
  },
  {
    disabled: false,
    value: 10,
    label: '人员密集单元',
    children: [
      {
        disabled: false,
        value: 205,
        label: '体育场馆'
      },
      {
        disabled: false,
        value: 202,
        label: '医疗机构'
      },
      {
        disabled: false, // 208
        value: 216,
        label: '星级饭店（酒店）' // 公路、水运工程
      },
      {
        disabled: false,
        value: 208,
        label: '宾馆酒店（非星级）'
      },
      {
        disabled: false, // 208
        value: 217,
        label: '民宿'
      },
      {
        disabled: false,
        value: 201,
        label: '餐饮场所'
      },
      {
        disabled: false, // 207
        value: 213,
        label: '技工院校'
      },
      {
        disabled: false, // 207
        value: 219,
        label: '职业技能培训机构'
      },
      {
        disabled: false,
        value: 207,
        label: '学校'
      },
      {
        disabled: false, // 207
        value: 220,
        label: '托育机构'
      },
      {
        disabled: false,
        value: 209,
        label: '养老机构和福利机构'
      },
      {
        disabled: false,
        value: 222,
        label: '殡仪服务场所'
      },
      {
        disabled: false,
        value: 211,
        label: '商场'
      },
      {
        disabled: false, // 211
        value: 223,
        label: '市场'
      },
      {
        disabled: false,
        value: 204,
        label: '宗教场所'
      },
      {
        disabled: false,
        value: 210,
        label: '文化娱乐行业'
      },
      {
        disabled: false,
        value: 215,
        label: '文物和博物馆'
      },
      {
        disabled: false,
        value: 224,
        label: '少年宫'
      },
      // {
      //   disabled: true,
      //   value: 225,
      //   label: '科技馆'
      // },
      {
        disabled: false,
        value: 226,
        label: '会展场馆'
      },
      {
        disabled: false,
        value: 227,
        label: '会堂场馆'
      },
      {
        disabled: false,
        value: 206,
        label: '旅游景区'
      },
      {
        disabled: false, // 206
        value: 228,
        label: '风景名胜区'
      },
      {
        disabled: false,
        value: 304,
        label: '客运车站'
      },
      {
        disabled: false,
        value: 229,
        label: '驾校'
      }
    ]
  },
  {
    disabled: false,
    value: 11,
    label: '公共设施单元',
    children: [
      {
        disabled: false,
        value: 133,
        label: '公路建设项目'
      },
      {
        disabled: false,
        value: 135,
        label: '在建水利水电项目（水利局）'
      },
      {
        disabled: false, // 135
        value: 323,
        label: '在建水电项目（工信局）'
      },
      {
        disabled: false,
        value: 309,
        label: '建筑垃圾消纳场'
      },
      {
        value: 325, // 113
        label: '发电企业（水力）（水利局）'
      },
      {
        value: 326, // 113
        label: '发电企业（水力）（工信局）'
      },
      {
        value: 327, // 113
        label: '发电企业（火力）'
      },
      {
        value: 306,
        label: '陆上长输油气管道企业'
      },
      {
        value: 315, // 111
        label: '快递企业'
      },
      {
        value: 307,
        label: '城镇燃气管道企业'
      },
      {
        value: 316,
        label: '城市供水企业'
      },
      {
        value: 317,
        label: '污水处理企业'
      },
      {
        value: 331, // 302
        label: '市政隧道（市政园林局）'
      },
      {
        value: 302,
        label: '公路隧道（交通运输局）'
      },
      {
        value: 332, // 206
        label: '城市公园'
      },
      {
        value: 333, // 301
        label: '市政桥梁（市政园林局）'
      },
      {
        value: 301,
        label: '公路桥梁（交通运输局）'
      },
      {
        value: 314,
        label: '道路普通货物运输企业'
      },
      {
        disabled: false,
        value: 335,
        label: '水路货物运输企业'
      },
      {
        value: 320,
        label: '水路旅客运输企业'
      },
      {
        value: 303,
        label: '水库大坝'
      },
      {
        value: 320,
        label: '水路旅客运输企业'
      },
      {
        disabled: false,
        value: 335,
        label: '水路货物运输企业'
      }
    ]
  }
]

// 专家服务-专家库级别下拉选项
export const expertTypeList = [
  {
    value: '国家级',
    label: '国家级'
  },
  {
    value: '省级',
    label: '省级'
  },
  {
    value: '地市级',
    label: '地市级'
  },
  {
    value: '区县级',
    label: '区县级'
  }
]

// 主要服务项目
export const majorServiceOptions = [
  // {value: '安全评价', label: '安全评价'},
  // {value: '安全标准化服务', label: '安全标准化服务'},
  // {value: '其他', label: '其他'},
  {value: '安全生产标准化服务', label: '安全生产标准化服务'},
  {value: '安全技术咨询', label: '安全技术咨询'},
  {value: '安全评估', label: '安全评估'},
  {value: '安全风险分级管控', label: '安全风险分级管控'},
  {value: '隐患排查治理', label: '隐患排查治理'},
  {value: '安全生产评价', label: '安全生产评价'},
  {value: '应急预案', label: '应急预案'},
  {value: '其他', label: '其他'}
]

// 主要服务行业领域
export const industriesOptions = [
  {value: '危化', label: '危化'},
  {value: '工贸', label: '工贸'},
  {value: '矿山', label: '矿山'},
  {value: '建筑', label: '建筑'},
  {value: '消防', label: '消防'},
  {value: '交通', label: '交通'},
  {value: '烟花爆竹', label: '烟花爆竹'},
  {value: '电力', label: '电力'},
  {value: '其他', label: '其他'}
]

// 资格证书名称
export const qualificationCertificateOptions = [
  '安全评价机构资质证书',
  '营业执照（或独立法人资格证书）',
  '职业卫生技术服务机构资质证书',
  '其他'
]

export const projectTypeOptions = [
  { value: '安全评价', label: '安全评价' },
  { value: '安全现状评价', label: '安全现状评价' },
  { value: '安全验收评价', label: '安全验收评价' },
  { value: '安全标准化服务', label: '安全标准化服务' },
  { value: '隐患排查', label: '隐患排查' },
  { value: '应急预案', label: '应急预案' },
  { value: '其他', label: '其他' }
]

// 职称
export const occupationNameOptions = [
  // '无',
  // '初级技术职称人员',
  // '中级技术职称人员',
  // '高级技术职称人员',
  // '省市级应急安全专家',
  // '其他',
  '无',
  '正高级',
  '副高级',
  '中级',
  '初级',
  '其他'
]

// 学历
export const educationOptions = [
  '高中',
  '中专',
  '专科',
  '本科',
  '研究生及以上',
  '其他'
]

// 人员信息-证书类型
export const personnelCertificateOptions = [
  '注册安全工程师',
  '安全评价师',
  '注册消防师',
  '高级工程技术职称',
  '省市级应急安全专家',
  '其他'
]



// WEBPACK FOOTER //
// ./src/Util/commonOptions.js